<template>
  <div>
    <v-dialog :value="dialog" max-width="700" @input="closeDialog">
      <v-card>
        <v-card-title> สาขา </v-card-title>
        <v-card-text>
          <v-row class="justify-end">
            <v-col cols="12" md="8">
              <v-btn
                color="primary"
                title="เพิ่มสาขา"
                outlined
                small
                @click="openDialogCreateMajor"
              >
                <v-icon left>fa-plus</v-icon>
                เพิ่มสาขา
              </v-btn>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="majorSearch"
                label="ค้นหา"
                solo
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
            :search="majorSearch"
            :loading="loading"
            :headers="majorHeaders"
            :items="majors"
            :items-per-page="100"
            sort-by="id"
            :footer-props="{
              itemsPerPageOptions: [25, 50, 75, 100, -1],
            }"
          >
            <template v-slot:[`item.no`]="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                color="primary"
                class="mr-2"
                title="แก้ไขข้อมูล"
                small
                @click="editMajor(item)"
              >
                fa-edit
              </v-icon>
              <v-icon
                color="primary"
                class="mr-2"
                title="ลบข้อมูล"
                small
                :disabled="item.can_delete"
                @click="deleteMajor(item.id)"
              >
                fa-trash
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeDialog" text> ปิด </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogCreateMajor
      :dialog.sync="dialogCreateMajor"
      :facultyId="facultyId"
    />
    <DialogEditMajor
      :dialog.sync="dialogEditMajor"
      :major="showMajor"
    />
  </div>
</template>

<script>
import { DELETE_MAJOR, GET_MAJORS_BY_FACULTY } from "@/store/action.type"
import { CONFIRM_DELETE } from "@/common/consistent"
import { swalConfirm } from "@/common/alert"
import { DialogCreateMajor, DialogEditMajor } from "@/components/dialog/major"

export default {
  name: "DialogShowMajors",
  components: {
    DialogCreateMajor,
    DialogEditMajor,
  },
  props: {
    dialog: {
      required: true,
      type: Boolean,
    },
    facultyId: {
      required: true,
      type: Number | String,
    },
    majors: {
      required: true,
      type: Array,
    },
    loading: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      majorSearch: "",
      majorHeaders: [
        { text: "ID", value: "id" },
        { text: "ชื่อสาขา", value: "name" },
        { text: "ตัวเลือก", value: "actions" },
      ],
      showMajor: {},
      dialogCreateMajor: false,
      dialogEditMajor: false,
    }
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false)
    },
    openDialogCreateMajor() {
      this.dialogCreateMajor = true
    },
    editMajor(major) {
      this.showMajor = major
      this.dialogEditMajor = true
    },
    deleteMajor(major_id) {
      swalConfirm("warning", CONFIRM_DELETE, async () => {
        await this.$store.dispatch(DELETE_MAJOR, major_id)
        this.$store.dispatch(GET_MAJORS_BY_FACULTY, this.facultyId)
      })
    },
  },
}
</script>